import LogoMark from './LogoMark';

export default LogoMark;
export type { LogoMarkProps } from './LogoMark';
